import { Box } from "@mui/material";
import { FC } from "react";
import { ScreenProps } from "./Screen.interfaces";

const Screen: FC<ScreenProps> = ({ children }) => <Box>{children}</Box>;

export default Screen;
